namespace Shared.Dto

open System

type Location = {
    Longitude: float
    Latitude: float
}

[<RequireQualifiedAccess>]
module Location =

    let create (longitude: float) (latitude: float) : Location option =
        let validatedLatitude =
            if -90. <= latitude && latitude <= 90. then
                Some latitude
            else
                None

        let validatedLongitude =
            if -180. <= longitude && longitude <= 180. then
                Some longitude
            else
                None

        Option.map2
            (fun long lat -> {
                Longitude = long
                Latitude = lat
            })
            validatedLongitude
            validatedLatitude

    /// Calculate the distance between two different Locations in meters
    let calculateDistanceTo (first: Location) (second: Location) : int =
        let d1 = first.Latitude * (Math.PI / 180.0)
        let num1 = first.Longitude * (Math.PI / 180.0)
        let d2 = second.Latitude * (Math.PI / 180.0)
        let num2 = second.Longitude * (Math.PI / 180.0) - num1

        let d3 =
            Math.Pow(Math.Sin((d2 - d1) / 2.0), 2.0)
            + Math.Cos(d1) * Math.Cos(d2) * Math.Pow(Math.Sin(num2 / 2.0), 2.0)

        6376500.0 * (2.0 * Math.Atan2(Math.Sqrt(d3), Math.Sqrt(1.0 - d3)))
        |> Math.Round
        |> int

    let isAdjacent (maxDistance: int) (first: Location) (second: Location) =
        let distance = calculateDistanceTo first second

        distance <= maxDistance

    let fromOptional (maybeLongitude: float option) (maybeLatitude: float option) : Location option =
        match maybeLongitude, maybeLatitude with
        | Some longitude, Some latitude -> create longitude latitude
        | _, _ -> None